import { SurveysRepository } from '../repositories/surveys.repository'
import {
    SurveyCreateVariantResponseT,
    SurveyGetSurveyResponseT,
    SurveyPayloadT,
    SurveysCreateResponseT,
    SurveysExcelResponseT,
    SurveysGetListResponseT,
    SurveyUpdatePayloadT,
    SurveyUpdateVariantResponseT,
    VariantPayloadT,
} from '../types/survey.types'

const surveysRepository = new SurveysRepository()

export class SurveysService {
    async getList(page: number): Promise<SurveysGetListResponseT> {
        const response = await surveysRepository.getList(page)
        return response.data
    }

    async deleteSurvey(survey_id: number): Promise<void> {
        const response = await surveysRepository.deleteSurvey(survey_id)
        return response.data
    }

    async deleteVariant(survey_id: number, variant_id: number): Promise<void> {
        const response = await surveysRepository.deleteVariant(survey_id, variant_id)
        return response.data
    }

    async createSurvey(payload: SurveyPayloadT): Promise<SurveysCreateResponseT> {
        const response = await surveysRepository.createSurvey(payload)
        return response.data
    }

    async updateSurvey(survey_id: number, payload: SurveyUpdatePayloadT): Promise<void> {
        const response = await surveysRepository.updateSurvey(survey_id, payload)
        return response.data
    }

    async getSurvey(survey_id: number): Promise<SurveyGetSurveyResponseT> {
        const response = await surveysRepository.getSurvey(survey_id)
        return response.data
    }

    async createVariant(
        survey_id: number,
        payload: VariantPayloadT
    ): Promise<SurveyCreateVariantResponseT> {
        const response = await surveysRepository.createVariant(survey_id, payload)
        return response.data
    }

    async updateVariant(
        survey_id: number,
        variant_id: number,
        payload: VariantPayloadT
    ): Promise<SurveyUpdateVariantResponseT> {
        const response = await surveysRepository.updateVariant(survey_id, variant_id, payload)
        return response.data
    }

    async exportExcel(): Promise<SurveysExcelResponseT> {
        const response = await surveysRepository.exportExcel()
        return response.data
    }
}
